// Format any date value as DD/MM/YYYY
export function fmtDate(val) {
  if (!val) return '';
  // YYYY-MM-DD string: parse parts directly to avoid UTC offset shifting the day
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(val))) {
    const [y, m, d] = String(val).split('-');
    return `${d}/${m}/${y}`;
  }
  const d = new Date(val);
  if (isNaN(d.getTime())) return String(val);
  return [
    String(d.getDate()).padStart(2, '0'),
    String(d.getMonth() + 1).padStart(2, '0'),
    d.getFullYear(),
  ].join('/');
}
